'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = isIdle;

/** Determine if the user has been idle for longer than a given threshold.
 *	@param {Number} threshold	A set amount of time after which, if there are no events, we consider the user idle.
 *	@returns {Bool}
 */

var timeOfLastEvent = Date.now(),
    events = ['scroll', 'mousedown', 'mousemove', 'keydown', 'touchstart'],
    initialized = false;

function isIdle() {
	var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60000;

	if (!initialized) {
		for (var i = 0; i < events.length; i++) {
			window.addEventListener(events[i], registerEvent);
		}

		initialized = true;
	}

	var delta = Date.now() - timeOfLastEvent;

	if (delta > threshold) {
		return true;
	}

	return false;
}

function registerEvent(e) {
	timeOfLastEvent = Date.now();
}
module.exports = exports['default'];


// WEBPACK FOOTER //
// ../node_modules/@cube/utils/lib/isIdle.js